import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import {surveyWaveEditSuccess} from '../../../actions/action_survey_wave';
import * as api from '../../../services/api';
import messages from '../../../../res/translations/messages';
import WaveForm from './WaveForm';

const WaveEdit = () => {
    const survey = useSelector((state) => state.survey.item);
    const {waveId} = useParams();
    const wave = survey.waves.find(({id}) => id === waveId);
    const initialValues = {
        name: wave.name,
        startDate: wave.startDate ? moment(wave.startDate).format('YYYY-MM-DD') : '',
        endDate: wave.endDate ? moment(wave.endDate).format('YYYY-MM-DD') : '',
    };
    const dispatch = useDispatch();
    const history = useHistory();
    const [submitting, setSubmitting] = React.useState(false);
    const handleSubmit = React.useCallback(
        (values) => {
            api.editSurveyWave(survey.id, waveId, values)
                .finally(() => {
                    setSubmitting(false);
                })
                .then((response) => {
                    dispatch(surveyWaveEditSuccess(response.data));
                    history.push(`/surveys/${survey.id}/trackers/wave/${waveId}`);
                });
        },
        [dispatch, history, survey.id, waveId]);
    return (
        <div className="survey-editor-item p-3">
            <h5><FormattedMessage {...messages.waves.edit.title} /></h5>
            <WaveForm initialValues={initialValues} onSubmit={handleSubmit} surveyId={survey.id} submitting={submitting} />
        </div>
    );
};

export default WaveEdit;
